import * as React from 'react';
import { SVGProps } from 'react';

const IconArrowLeftSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="m3.293 6 3.975-3.975.707.707L4.707 6l3.268 3.268-.707.707L3.293 6z"
      fillRule="evenodd"
      clipRule="evenodd"
    />
  </svg>
);

export default IconArrowLeftSizeXs;
